import { RESIZE_HANDLE_TYPES } from '../../components/GridLayoutResizeControls';
import { getPegboardElementComputedSpanning } from 'layout-dnd-utils/geometry/pegboard';
export const computeModuleGridAreaOnPegboard = (originalGridArea, resizeHandle, hoveredRow, hoveredColumn) => {
  const {
    rowStart,
    columnStart,
    rowSpan,
    columnSpan
  } = originalGridArea;
  let newRowStart = rowStart;
  let newColumnStart = columnStart;
  let newRowSpan = rowSpan;
  let newColumnSpan = columnSpan;
  if (resizeHandle === RESIZE_HANDLE_TYPES.RIGHT && hoveredColumn >= columnStart) {
    newColumnSpan = hoveredColumn - columnStart + 1;
  } else if (resizeHandle === RESIZE_HANDLE_TYPES.LEFT && hoveredColumn <= columnStart + columnSpan) {
    newColumnSpan = columnStart - hoveredColumn + columnSpan;
    newColumnStart = hoveredColumn;
  } else if (resizeHandle === RESIZE_HANDLE_TYPES.TOP && hoveredRow <= rowStart + rowSpan) {
    newRowStart = hoveredRow;
    newRowSpan = rowStart - hoveredRow + rowSpan;
  } else if (resizeHandle === RESIZE_HANDLE_TYPES.BOTTOM && hoveredRow >= rowStart) {
    newRowSpan = hoveredRow - rowStart + 1;
  } else if (resizeHandle === RESIZE_HANDLE_TYPES.TOP_LEFT && hoveredRow <= rowStart + rowSpan && hoveredColumn <= columnStart + columnSpan) {
    newRowStart = hoveredRow;
    newColumnStart = hoveredColumn;
    newRowSpan = rowStart - hoveredRow + rowSpan;
    newColumnSpan = columnStart - hoveredColumn + columnSpan;
  } else if (resizeHandle === RESIZE_HANDLE_TYPES.TOP_RIGHT && hoveredRow <= rowStart + rowSpan && hoveredColumn >= columnStart) {
    newRowStart = hoveredRow;
    newRowSpan = rowStart - hoveredRow + rowSpan;
    newColumnSpan = hoveredColumn - columnStart + 1;
  } else if (resizeHandle === RESIZE_HANDLE_TYPES.BOTTOM_LEFT && hoveredRow >= rowStart && hoveredColumn <= columnStart + columnSpan) {
    newColumnStart = hoveredColumn;
    newRowSpan = hoveredRow - rowStart + 1;
    newColumnSpan = columnStart - hoveredColumn + columnSpan;
  } else if (resizeHandle === RESIZE_HANDLE_TYPES.BOTTOM_RIGHT && hoveredRow >= rowStart && hoveredColumn >= columnStart) {
    newColumnSpan = hoveredColumn - columnStart + 1;
    newRowSpan = hoveredRow - rowStart + 1;
  }
  return {
    newRowStart,
    newColumnStart,
    newRowSpan,
    newColumnSpan
  };
};
export const updatePegboardElementDom = (selectedElement, newGridArea) => {
  const {
    rowStart,
    columnStart,
    rowSpan,
    columnSpan
  } = newGridArea;
  selectedElement.style.setProperty('grid-row', `${rowStart} / span ${rowSpan}`);
  selectedElement.style.setProperty('grid-column', `${columnStart} / span ${columnSpan}`);
};
export const isResizingPastMinimumDimensions = (pegboardNodePosition, selectedElement, newGridSpanning) => {
  const {
    rowSpan,
    columnSpan
  } = newGridSpanning;
  const {
    rowSize,
    rowGap,
    columnSize,
    columnGap
  } = pegboardNodePosition;
  const {
    height,
    width
  } = selectedElement.getBoundingClientRect();
  const computedRowsSpanned = getPegboardElementComputedSpanning({
    elementSize: height,
    cellSize: rowSize,
    gap: rowGap
  });
  const computedColumnsSpanned = getPegboardElementComputedSpanning({
    elementSize: width,
    cellSize: columnSize,
    gap: columnGap
  });
  return computedRowsSpanned > rowSpan || computedColumnsSpanned > columnSpan;
};